export default "__VITE_ASSET__iuHen0gu__"